var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.svgIcon,{tag:"component",class:[("icon-color_" + _vm.color)],style:({ width: _vm.size, height: _vm.size, minWidth: _vm.size }),attrs:{"width":_vm.size,"height":_vm.size}})}
var staticRenderFns = []

export { render, staticRenderFns }